import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { MarketModel } from '../models/market.model';
import { ProfileModel } from '../models/profile.model';
import { TourneeModel } from '../models/tournee.model';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { DataService } from '../services/data/data.service';
import { HomeService } from '../services/home-service/home.service';

@Injectable({
  providedIn: 'root'
})
export class LinkGuard implements CanActivate {
 
  constructor(private auth: AuthenticationService, private navCtrl:NavController, private router:Router, 
     private dataService:DataService, private homeService:HomeService) {
     }
 
  async canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot) {   
    const link3 = route.paramMap.get('link3');
    let link2 = route.paramMap.get('link2');
    let link1 = route.paramMap.get('link1');
    const link1Split = link1.split(',');
    if(!link2 && link1Split.length ==2){
      link2 = link1Split[1];
      link1 = link1Split[0];
    }
    const result = await firstValueFrom(this.dataService.getLink(link1,link2,link3));
    console.log(result, link1, link2, link3);
    let item:any;
    if(link1 && link2 && link3 && result[link2] && result[link2][link3]){
      item = result[link2][link3];
    }
    else if(link1 && link2 && result[link2]){
      item = result[link2];
    }
    else {
      item = result;
    }
    console.log(item);
    if(item.referenceKey){
      if(item.type =='producer'){
        const producer:ProfileModel = {
          key:item.referenceKey,
          role:'producer'
        }
        return this.router.parseUrl('/profile/producer/'+item.referenceKey);
      }
      else if(item.type == 'sale'){
        const sale:TourneeModel = {
          key:item.referenceKey
        }
        return this.router.parseUrl('/sale/'+item.referenceKey);
      }
      else if(item.type == 'market'){
        const sale:MarketModel = {
          key:item.referenceKey
        }
        return this.router.parseUrl('/market/'+item.referenceKey);
      }
      else{
        return true;
      }
    }
  }
}